import { cx } from "@linaria/core"

import { HeadingStyles } from "@/styles/Markdown.ts"

import type { HTMLAttributes, RefAttributes } from "react"


type HeadingProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

export const Heading1 = (props: HeadingProps) => {
  return (
    <div {...props} className={cx(HeadingStyles.Heading1, props.className)} role="heading" aria-level={1}>
      {props.children}
    </div>
  )
}

export const Heading2 = (props: HeadingProps) => {
  return (
    <div {...props} className={cx(HeadingStyles.Heading2, props.className)} role="heading" aria-level={2}>
      {props.children}
    </div>
  )
}

export const Heading3 = (props: HeadingProps) => {
  return (
    <div {...props} className={cx(HeadingStyles.Heading3, props.className)} role="heading" aria-level={3}>
      {props.children}
    </div>
  )
}

export const Heading4 = (props: HeadingProps) => {
  return (
    <div {...props} className={cx(HeadingStyles.Heading4, props.className)} role="heading" aria-level={4}>
      {props.children}
    </div>
  )
}

export const Heading5 = (props: HeadingProps) => {
  return (
    <div {...props} className={cx(HeadingStyles.Heading5, props.className)} role="heading" aria-level={5}>
      {props.children}
    </div>
  )
}

export const Heading6 = (props: HeadingProps) => {
  return (
    <div {...props} className={cx(HeadingStyles.Heading6, props.className)} role="heading" aria-level={6}>
      {props.children}
    </div>
  )
}
